import { SnapshotRow, ValidationError } from '../types/borrowerChecker'

export function validateRequiredFields(row: SnapshotRow): ValidationError[] {
  const errors: ValidationError[] = []

  if (!row.lenderLoanId || row.lenderLoanId.trim() === '') {
    errors.push({
      row: row.rowNumber,
      field: 'Lender Loan ID',
      message: 'Lender Loan ID is required',
    })
  }

  if (!row.borrowerName || row.borrowerName.trim() === '') {
    errors.push({
      row: row.rowNumber,
      field: 'Borrower Name',
      message: 'Borrower Name is required',
    })
  }

  return errors
}

export function validateSnapshot(rows: SnapshotRow[]): {
  validRows: SnapshotRow[]
  errors: ValidationError[]
} {
  const validRows: SnapshotRow[] = []
  const errors: ValidationError[] = []

  for (const row of rows) {
    const rowErrors = validateRequiredFields(row)
    if (rowErrors.length === 0) {
      validRows.push(row)
    } else {
      errors.push(...rowErrors)
    }
  }

  return { validRows, errors }
}
